module.exports = __webpack_public_path__ + "img/ziperase_logo_Light.d6278f88.png";